import classNames from 'classnames';
import Image from 'next/image';
import styles from './StoreBadgeBase.module.scss';

type StoreBadgeBaseProps = {
  height: number;
  noReferrer: boolean;
  className?: string;
  storeUrl: string;
  altText: string;
  src: string;
};

const StoreBadgeBase = ({ height, className = '', noReferrer, storeUrl, altText, src }: StoreBadgeBaseProps) => {
  return (
    <a href={storeUrl} target="_blank" rel={noReferrer ? 'noreferrer' : ''}>
      <Image height={height} src={src} className={classNames(styles.baseClass, className)} alt={altText} />
    </a>
  );
};

export default StoreBadgeBase;
